define('MultiAddToCart.ItemRow.View', [
    'multi_add_to_item_row.tpl',

    'Facets.MultiAddToCart.Quantity.View',

    'Backbone'
], function (
    multi_add_to_item_row_tpl,

    FacetsMultiAddToCartQuantityView,

    Backbone
) {
    'use strict';

    return Backbone.View.extend({
        template: multi_add_to_item_row_tpl,

        initialize: function initialize(options) {
            this.item = options.item;
            this.container = options.container;
            this.plp = this.container.getComponent('PLP');
            this.env = this.container.getComponent('Environment');
            this.getRegistrationType = options.getRegistrationType;
            this.addToCartViews = options.addToCartViews;
            this.isloggedin = options.isloggedin;
            this.on('afterViewRender', this.afterShowContent, this);
        },

         childViews: {
            'Facets.MultiAddToCart.Quantity': function () {
                return new FacetsMultiAddToCartQuantityView({
                    container: this.container,
                    getRegistrationType: this.getRegistrationType,
                    addToCartViews: this.addToCartViews,
                    item: this.item
                });
            }
        },

         //show part number and description

         afterShowContent: function afterShowContent(){
            // var webcategorylists = this.env.getConfig('webcategorylists') || [];
            var categoryinfo = this.plp.getCategoryInfo();
            if(categoryinfo && categoryinfo.internalid) {
                jQuery('.part-number-category-' + categoryinfo.internalid).show();
                jQuery('.part-desc-number-category-' + categoryinfo.internalid).show();

                jQuery('.facets-browse-category-heading-main-image').css("text-align", "center");
                jQuery('.facets-browse-category-heading-main-image img').css({"max-height": "1200", "width": "auto"});
            }
         },
                 

        getContext: function () {
                        
            return {
                item: this.item,
                // @property {String} itemId
                itemId: this.item.internalid,
                // @property {String} name
                name: this.item.name,
                // @property {String} url
                url: '/' + this.item.urlcomponent, 
                // @property {String} sku
                sku: this.item.itemid,
                // @property {Boolean} isEnvironmentBrowser
                // @property {ImageContainer} thumbnail
                thumbnail: this.item.keyMapping_thumbnail,
                // @property {Boolean} itemIsNavigable
                itemIsNavigable:  this.item.itemIsNavigable,
                // @property {Boolean} showRating
                showRating:  this.item.showRating,
                // @property {Number} rating
                rating:  this.item.rating,
                // @property {String} track_productlist_list
                track_productlist_list:  this.item.track_productlist_list,
                // @property {String} track_productlist_position
                track_productlist_position: this.item.track_productlist_position,
                // @property {String} track_productlist_category
                track_productlist_category:  this.item.track_productlist_category,
                custitem_sc_part_desc:  this.item.custitem_sc_part_desc,
                custitem_sc_part_index:  this.item.custitem_sc_part_index,
                custitem_rank: this.item.custitem_rank,
                isLoggedIn: this.isloggedin,
                priceFormatted: this.item.onlinecustomerprice_detail && this.item.onlinecustomerprice_detail.onlinecustomerprice_formatted,
                isNotPurchasable: !this.item.ispurchasable
            };
        }
    });
});
